var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3228 15.2071C26.989 12.6605 25.7385 10.3228 23.8054 8.63166C21.8724 6.94054 19.3892 6.0119 16.8208 6.01958C14.2524 6.02726 11.7749 6.97073 9.85192 8.67339C7.92899 10.376 6.6925 12.7212 6.37393 15.2697C6.05536 17.8183 6.67654 20.3956 8.12119 22.5192C9.56584 24.6428 11.7349 26.1671 14.2224 26.8068C16.7099 27.4465 19.3452 27.1576 21.6351 25.9944C23.925 24.8311 25.7124 22.8732 26.6628 20.4871M27.3228 27.0871V20.4871H20.7228",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.68,
    height: 31.68,
    fill: "white",
    transform: "translate(0.98877 0.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.b72d792323fd97b6d86eeaafcceb812d.svg";
export { ForwardRef as ReactComponent };